import React from "react";
import { TransactionsSummary } from "../../../../components/Transactions";

class SummaryScreen extends React.Component {
  render() {
    return <TransactionsSummary />;
  }
}

export default SummaryScreen;
